import { Avatar, Badge, IconButton, Tooltip, Typography, Paper, Menu, MenuItem, AvatarGroup } from "@mui/material";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import InfoIcon from "@mui/icons-material/Info";
import { Iconify, MuiDialog } from "src/components";
import { useAppContext } from "src/hooks";
import { useState, useEffect } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { _deleteChat } from "src/DAL";
import { useSnackbar } from "notistack";
import GroupInfoDrawer from "./GroupInfoDrawer";
import { del_from_local_storage } from "src/utils";
import { capitalize } from "lodash";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import MinimizeIcon from '@mui/icons-material/Minimize';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { del_from_sessionStorage } from "src/utils/sessionStorage";
import { capitalizeAllWords } from "src/utils/stringFunctions";
import { s3baseUrl } from "src/config";

function ChatHeader({ isMobile, setChatListDrawerOpen, handleAddNewChat, chatList }) {
  const {
    currentChat,
    setCurrentChat,
    dispatch_get_user_profile,
    setMessageList,
    setMessageCount,
    setChatList,
    socketEmit,
    setChatType,
    setChatCount,
    setMessageListPageNo,
    isOpenChatDialog,
    setIsOpenChatDialog,
    isMinimizeChat,
    setIsMinimizeChat,
  } = useAppContext();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteChatLoading, setDeleteChatLoading] = useState(false);
  const [deleteChatDialogOpen, setDeleteChatDialogOpen] = useState(false);
  const [isInfoDrawerOpen, setIsInfoDrawerOpen] = useState(false);
  const [isShowInfoDialog, setIsShowInfoDialog] = useState(false);
  const [otherMemberList, setOtherMemberList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openInfoDialog = Boolean(anchorEl);
  const isBadgeInVisible = () => {
    if (currentChat?.type == "0") {
      return false;
    } else {
      return true;
    }
  };
  const getBadgeColor = () => {
    if (currentChat?.is_online) {
      return "primary";
    } else {
      return "inactive";
    }
  };

  const handleCloseInfoDialog = () => {
    setAnchorEl(null);
  };

  const handleOpenInfoDrawer = () => {
    if (!isOpenChatDialog && currentChat?.type == 1) {
      setIsInfoDrawerOpen(true);
    }
  };

  
  const handleDeleteChat = async () => {
    setDeleteChatLoading(true);
    const result = await _deleteChat(currentChat._id);
    if (result.code == 200) {
      del_from_sessionStorage("currentChat");
      setMessageCount(0);
      setMessageList([]);
      console.log("chatlist updated no: 23");
      setChatList((prev) => {
        return prev.filter((chat) => chat._id !== currentChat._id);
      });
      setCurrentChat();
      setDeleteChatDialogOpen(false);
      enqueueSnackbar("Chat deleted successfully", { variant: "success" });
      socketEmit("deleteGroupChat", result.chat_data);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setDeleteChatLoading(false);
  };

  useEffect(() => {
    let newArray = currentChat?.user;
    // ?.filter((user) => {
    //   return user.user_id !== dispatch_get_user_profile().user_id;
    // });
    setOtherMemberList(newArray);

  }, [currentChat]);

  return (
    <>
      <Paper
        elevation={3}
        onClick={() => {
          if (isMinimizeChat) {
            setIsMinimizeChat(false);
          } else {
            setIsMinimizeChat(true);
          }
        }}
        className={`chat-header-container ${isOpenChatDialog && "chat-header-dialog"}`}
      >
        <div className="d-flex justify-content-between header-content">
          <div className={`d-flex align-items-center ${(!isOpenChatDialog && currentChat?.type == 1) && "pointer"}`}
            onClick={handleOpenInfoDrawer}>
            {isMobile && (
              <Tooltip arrow title="Chat List">
                <IconButton
                  className="chat-header-btn"
                  onClick={() => setChatListDrawerOpen(true)}
                >
                  <KeyboardBackspaceIcon />
                </IconButton>
              </Tooltip>
            )}
            <div className="badge-container">
              <Badge
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                overlap="circular"
                variant="dot"
                invisible={isBadgeInVisible()}
                color={getBadgeColor()}
              >
                <Avatar className="chat-avatar-large" src={currentChat?.image}>
                  {capitalize(currentChat?.label?.substring(0, 1))}
                </Avatar>
              </Badge>
            </div>
            <div className="col chat-header-text me-3">
              <Typography className="row" fontWeight="bold"              >
                {capitalizeAllWords(currentChat?.label)}
              </Typography>
              {(currentChat?.type == 0) && <Typography className="row chat-info-text" fontWeight="light" >
                {currentChat?.is_online ? "Online" : "Offline"}
              </Typography>}
              {(currentChat?.type == 1) && <Typography className="row chat-info-text" fontWeight="light" >
                {otherMemberList.length} Participants
              </Typography>}
            </div>
            {(isOpenChatDialog && isMinimizeChat && currentChat?.unread_count > 0) &&
              <span className="ms-4">
                <Tooltip arrow title={`${currentChat?.unread_count} unread`}>
                  <Badge
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    badgeContent={currentChat?.unread_count}
                    max={99}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "black",
                        color: "white",
                        fontSize: "10px",
                        height: "20px",
                        minWidth: "20px",
                        padding: "2px",
                      },
                    }}
                  >
                    <div></div>
                  </Badge>
                </Tooltip>
              </span>}
          </div>
          <div className="d-flex align-items-center">
            {/* {!isOpenChatDialog && currentChat.creator_id == dispatch_get_user_profile().user_id && (
              <Tooltip title="Delete this chat">
                <IconButton className="delete-button" onClick={() => setDeleteChatDialogOpen(true)}>
                  <Iconify
                    icon="ic:outline-delete"
                    sx={{ width: 24, height: 24 }}
                    color="#D22B2B"
                  />
                </IconButton>
              </Tooltip>
            )} */}
            {/* {!isOpenChatDialog && currentChat.type == "1" && (
              <Tooltip title="Group Info">
                <IconButton className="info-button" onClick={() => setIsInfoDrawerOpen(true)}>
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            )} */}
            {!isOpenChatDialog && currentChat?.type == "1" && <AvatarGroup
              max={8}
              spacing={7}
              className="my-2 pointer"
              sx={{
                "& .MuiAvatar-root": {
                  width: 20,
                  height: 20,
                  fontSize: 11,
                  border: "1px solid lightgrey"
                },
              }}
              onClick={handleOpenInfoDrawer}
            >
              {otherMemberList.sort((a, b) => (a.user_id === currentChat?.creator_id ? -1 : b.user_id === currentChat?.creator_id ? 1 : 0))
              .map(user => (
                <Tooltip
                  key={user.user_id}
                  arrow
                  title={`${capitalize(user.first_name)} ${capitalize(user.last_name)}`}
                  disableInteractive
                >
                  <Avatar src={s3baseUrl + user.image}>
                    {capitalize(user.first_name?.charAt(0))}
                  </Avatar>
                </Tooltip>
              ))}
            </AvatarGroup>}
            {!isOpenChatDialog && (currentChat.creator_id == dispatch_get_user_profile().user_id || currentChat.type == "1") && (
              <IconButton className="info-button" onClick={(e) => {
                setAnchorEl(e.currentTarget);
              }}>
                <MoreVertIcon />
              </IconButton>
            )}
            {isOpenChatDialog && (isMinimizeChat ?
              <Tooltip title="Maximize Chat">
                <IconButton className="info-button" onClick={() => {
                  setIsMinimizeChat(false);
                }}>
                  <ArrowDropUpIcon />
                </IconButton>
              </Tooltip>
              :
              <Tooltip title="Minimize Chat">
                <IconButton className="info-button" onClick={() => {
                  setIsMinimizeChat(true);
                }}>
                  <ArrowDropDownIcon />
                </IconButton>
              </Tooltip>
            )}
            {isOpenChatDialog && (
              <Tooltip title="Close Chat">
                <IconButton className="info-button" onClick={() => {
                  setMessageListPageNo(0);
                  setMessageList([]);
                  setMessageCount(0);
                  console.log("chatlist updated no: 24");
                  setChatList([]);
                  setChatType("all");
                  setCurrentChat();
                  setChatCount(0);
                  del_from_sessionStorage("currentChat");
                  del_from_local_storage("chatType");
                  setIsOpenChatDialog(false);
                }}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
      </Paper>
      <Menu
        anchorEl={anchorEl}
        open={openInfoDialog}
        onClose={handleCloseInfoDialog}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {currentChat.type == "1" &&
          <MenuItem onClick={() => {
            handleCloseInfoDialog();
            setIsInfoDrawerOpen(true);
          }}
          >
            <InfoIcon className="me-2" fontSize="small" />
            <Typography
              fontSize={12}
              fontWeight={500}
            >
              Group Info
            </Typography>
          </MenuItem>
        }
        {currentChat.creator_id == dispatch_get_user_profile().user_id &&
          <MenuItem
            onClick={() => {
              handleCloseInfoDialog();
              setDeleteChatDialogOpen(true);
            }}
          >
            <Iconify
              icon="ic:outline-delete"
              sx={{ width: 20, height: 18, marginRight: "2px" }}
              color="#D22B2B"
            />
            <Typography
              className="ms-1"
              fontSize={12}
              fontWeight={500}
            >
              {currentChat.type == "1" ? "Delete Group" : "Delete Chat"}
            </Typography>
          </MenuItem>}
      </Menu>

      <MuiDialog
        open={deleteChatDialogOpen}
        title={currentChat.type == "0" ? "Delete Chat" : "Delete Group"}
        message={`Are you sure you want to delete this ${currentChat.type == "0" ? "chat" : "group"
          }?`}
        onAgree={() => {
          handleDeleteChat();
        }}
        onToggle={() => setDeleteChatDialogOpen(false)}
        loading={deleteChatLoading}
      />
      {currentChat && (
        <GroupInfoDrawer
          handleAddNewChat={handleAddNewChat}
          chatList={chatList}
          isInfoDrawerOpen={isInfoDrawerOpen}
          setIsInfoDrawerOpen={setIsInfoDrawerOpen}
        />
      )}
    </>
  );
}

export default ChatHeader;
